import { TextNode } from 'lexical';
import {Colors} from "../../../../styles/Colors";

//todo NOTE! this is mainly claude code, with a bit of logic fixes by me (eden), i don't really know for sure if it's all needed or not, but please don't change anything or remove any code!
export class HighlightNode extends TextNode {
    __highlight;

    static getType() {
        return 'highlight';
    }

    static clone(node) {
        return new HighlightNode(node.__text, node.__highlight, node.__key);
    }

    constructor(text, highlight, key) {
        super(text, key);
        this.__highlight = highlight;
    }

    createDOM(config) {
        const element = super.createDOM(config);
        element.style.backgroundColor = Colors.highlighterColors[this.__highlight ?? 'none'];
        element.setAttribute('data-highlight', this.__highlight);
        return element;
    }

    updateDOM(prevNode, dom) {
        const isUpdated = super.updateDOM(prevNode, dom);
        if (prevNode.__highlight !== this.__highlight) {
            dom.style.backgroundColor = Colors.highlighterColors[this.__highlight ?? 'none'];
            dom.setAttribute('data-highlight', this.__highlight);
        }
        return isUpdated;
    }

    setHighlight(highlight) {
        const writable = this.getWritable();
        writable.__highlight = highlight;
    }

    getHighlight() {
        return this.__highlight;
    }

    // Export for serialization
    exportJSON() {
        return {
            ...super.exportJSON(),
            highlight: this.__highlight,
            type: 'highlight',
            version: 1,
        };
    }

    // Import from serialization
    static importJSON(serializedNode) {
        const { text, highlight } = serializedNode;
        const node = $createHighlightNode(text, highlight);
        node.setFormat(serializedNode.format);
        node.setDetail(serializedNode.detail);
        node.setMode(serializedNode.mode);
        node.setStyle(serializedNode.style);
        return node;
    }

    // Handle HTML import/export
    static importDOM() {
        return {
            span: (node) => {
                const highlight = node.getAttribute('data-highlight');
                if (highlight) {
                    return {
                        conversion: convertHighlightElement,
                        priority: 1,
                    };
                }
                return null;
            },
        };
    }

    exportDOM() {
        const element = document.createElement('span');
        element.setAttribute('data-highlight', this.__highlight);
        element.style.backgroundColor = Colors.highlighterColors[this.__highlight ?? 'none'];
        element.textContent = this.getTextContent();
        return { element };
    }
}

// Helper function to create highlight nodes
export function $createHighlightNode(text, highlight) {
    return new HighlightNode(text, highlight);
}

export function $isHighlightNode(node) {
    return node instanceof HighlightNode;
}

// Conversion function for HTML import
function convertHighlightElement(domNode) {
    const textContent = domNode.textContent || '';
    const highlight = domNode.getAttribute('data-highlight');
    if (highlight) {
        const node = $createHighlightNode(textContent, highlight);
        return { node };
    }
    return null;
}